<template>
    <div>
        <b-form-group :label="customLabel" label-for="level_1_id">
            <v-select
                v-model="level1id"
                class="pt-0" label="name" name="name"
                :reduce="(option) => option.id"
                :options="levels1List"
                :disabled="disabled"
            />
            <small v-if="validation" class="text-danger">
                {{ validation }}</small>
        </b-form-group>
    </div>
</template>

<script>
import {BFormGroup} from 'bootstrap-vue'
import vSelect from "vue-select"

export default {
    components: {
        BFormGroup,
        vSelect,
    },
    props: {
        //eslint-disable-next-line vue/prop-name-casing
        level1id: {
            type: Number,
            default: null
        },
        validation: {
            type: String,
            default: null
        },
        disabled: {
            type: Boolean,
            default: false
        },
        customLabel: {
            type: String,
            default: "Nível 1"
        }
    },
    data() {
        return {
            levels1List: [],
            localLevel1Id: this.level1id,
        }
    },
    watch: {
        level1id(newVal) {
            this.localLevel1Id = newVal
            this.$emit('update', { level_1_id: this.localLevel1Id })
        },
    },
    mounted() {
        this.getLevels1()
    },
    methods:{
        getLevels1() {
            this.showLoading = true

            this.$store.dispatch('level1Vhe/getAllLevels1')
            .then(response => {
                this.levels1List = response

                this.showLoading = false
            })
            .catch(error => {
                this.showLoading = false
            })
        },
    },
}
</script>
